import step1Img from "../../assets/image/newuireg.svg";
import step2Img from "../../assets/image/filternew.svg";
import step3Img from "../../assets/image/update newcc.svg";

export const howItWorksContent = {
  badge: {
    text: "Simple Process",
  },
  heading: "How Does You Apply",
  description: "Get started with automated job sourcing in three simple steps",
};

export const steps = [
  {
    number: "1",
    image: step1Img,
    title: "Create Your Account",
    description:
      "Start by creating your company profile. No credit card required, get started in minutes.",
  },
  {
    number: "2",
    image: step2Img,
    title: "Configure Job Filters",
    description:
      "Customize your search criteria by location, skill, experience level and job sources.",
  },
  {
    number: "3",
    image: step3Img,
    title: "Get Daily Updates",
    description:
      "Receive structured job data automatically from multiple sources in your dashboard.",
  },
];
